
"use strict";

var Duration = require('./duration'),
    RelativeDate = require('./relativedate');

var predefinedIntervalsRevMap = {
    "####-##-##/P1D": "today",
    "####-##-##T00:00:00.000/P1D": "today",
    "####-##-##T00:00:00/P1D": "today",
    "####-###/P1D": "today",
    "####-###T00:00:00.000/P1D": "today",
    "####-###T00:00:00/P1D": "today",
    "####-W##-1/P7D": "this_week",
    "####-W##-1T00:00:00.000/P7D": "this_week",
    "####-W##-1T00:00:00/P7D": "this_week",
    "####-##-01/P1M": "this_month",
    "####-##-01T00:00:00.000/P1M": "this_month",
    "####-##-01T00:00:00/P1M": "this_month",
    "P1D/####-###": "yesterday",
    "P1D/####-###T00:00:00.000": "yesterday",
    "P1D/####-###T00:00:00": "yesterday",
    "P1D/####-##-##": "yesterday",
    "P1D/####-##-##T00:00:00.000": "yesterday",
    "P1D/####-##-##T00:00:00": "yesterday",
    "P1W/####-W##-1": "last_week",
    "P1W/####-W##-1T00:00:00.000": "last_week",
    "P1W/####-W##-1T00:00:00": "last_week",
    "P1M/####-##-01": "last_month",
    "P1M/####-##-01T00:00:00.000": "last_month",
    "P1M/####-##-01T00:00:00": "last_month",
    "PT1H": "last_hour",
    "PT1M": "last_minute"
};
var lastIntervals = {
    "seconds": "PTxS",
    "minutes": "PTxM",
    "hours": "PTxH",
    "days": "PxD/####-##-##T24:00:00.000",
    "weeks": "PxW/####-W##-8T00:00:00.000",
    "months": "PxM/####-##-31T00:00:00.000"
};
var lastIntervalRe = /^last_(\d+)_(seconds|minutes|hours|days|weeks|months)$/;

var predefinedIntervals = {};

Object.keys(predefinedIntervalsRevMap).forEach(function (key) {
    predefinedIntervals[predefinedIntervalsRevMap[key]] = key;
});

var lastIntervalsPeriods = Object.keys(lastIntervals)
    , lastIntervalsRevRe = new RegExp(lastIntervalsPeriods.map(function (period) {
    return '^' + lastIntervals[period].replace('x', '(\\d+)').replace('.', '\\.') + '$';
}).join('|'));


function RelativeInterval(interval, defaultTimezone) {
    var dateStart, dateEnd;

    if (!(this instanceof RelativeInterval)) {
        if (interval instanceof RelativeInterval) return interval;
        return new RelativeInterval(interval, defaultTimezone);
    }

    if ('string' === typeof interval) {
        parseInterval(this, interval);
        dateStart = this.start;
        dateEnd = this.end;
    }
    else if (interval !== null && 'object' === typeof interval) {
        if (interval.strict) {
            this.start = interval.dates[0];
            this.end = interval.dates[1];
            this.relative = false;
            this.duration = 'strict';
        } else if (interval.length === 2) {
            dateStart = interval[0];
            dateEnd = interval[1];

            this.start = dateStart = new RelativeDate(dateStart);
            this.end = dateEnd = new RelativeDate(dateEnd);
            this.relative = dateStart.relative || dateEnd.relative;
        } else {
            throw new TypeError("interval must be an ISO 8601 time interval string");
        }
    } else {
        throw new TypeError("interval must be an ISO 8601 time interval string");
    }

    if ('string' === typeof defaultTimezone && defaultTimezone.length !== 0) {
        if (dateStart !== undefined && dateStart.timezone == null) {
            dateStart.timezone = defaultTimezone;
            delete dateStart.source;
            delete this.source;
        }
        if (dateEnd !== undefined && dateEnd.timezone == null) {
            dateEnd.timezone = defaultTimezone;
            delete dateEnd.source;
            delete this.source;
        }
    }
}

RelativeInterval.prototype.isAbsolute = function () {
    return !this.relative;
};

RelativeInterval.prototype.isRelative = function () {
    return this.relative;
};

RelativeInterval.prototype.hasFutureStart = function (refdate) {
    if (refdate == null) refdate = Date.now();
    if ('number' !== typeof refdate && !(refdate instanceof Date)) {
        refdate = new Date(refdate);
    }
    return (this.startDate(refdate).getTime() > refdate);
};

RelativeInterval.prototype.hasFutureEnd = function (refdate) {
    if (refdate == null) refdate = Date.now();
    if ('number' !== typeof refdate && !(refdate instanceof Date)) {
        refdate = new Date(refdate)
    }
    return (this.endDate(refdate).getTime() > refdate);
};

RelativeInterval.prototype.toDates = function (refdate) {
    var date
        , startDate = this.start
        , endDate = this.end
        , duration = this.duration;

    if (startDate !== undefined) {
        if (endDate !== undefined) {
            if (duration === 'strict') {
                return [startDate, endDate];
            }

            return [startDate.toDate(refdate), endDate.toDate(refdate)];
        } else {
            return [startDate.toDate(refdate), startDate.toAddedDurationDate(duration, refdate)];
        }
    }
    else if (endDate !== undefined) {
        return [endDate.toSubtractedDurationDate(duration, refdate), endDate.toDate(refdate)];
    }
    else {
        date = refdate == null ? new Date()
            : new Date(refdate);
        return [duration.subtractFromDate(new Date(date)), date];
    }
};

RelativeInterval.prototype.startDate = function (refdate) {
    var startDate = this.start
        , endDate = this.end
        , duration = this.duration;

    if (startDate !== undefined) {
        return startDate.toDate(refdate);
    }
    else if (endDate !== undefined) {
        return endDate.toSubtractedDurationDate(duration, refdate);
    }
    else {
        return duration.subtractFromDate(refdate == null ? new Date()
            : new Date(refdate));
    }
};

RelativeInterval.prototype.endDate = function (refdate) {
    var startDate = this.start
        , endDate = this.end
        , duration = this.duration;

    if (endDate !== undefined) {
        return endDate.toDate(refdate);
    }
    else if (startDate !== undefined) {
        return startDate.toAddedDurationDate(duration, refdate);
    }
    else {
        return refdate == null ? new Date() : new Date(refdate);
    }
};

RelativeInterval.prototype.toJSON = function () {
    return this.toString();
};

RelativeInterval.prototype.toString = function (forceISO) {
    var value = this.source;
    if (value !== undefined && !forceISO) return value;

    var startDate = this.start
        , endDate = this.end
        , duration = this.duration;

    if (startDate !== undefined) {
        if (endDate !== undefined) {
            value = startDate.toString(forceISO) + '/' + endDate.toString(forceISO);
        }
        else {
            value = startDate.toString(forceISO) + '/' + duration.toString(forceISO);
        }
    }
    else if (endDate !== undefined) {
        value = duration.toString(forceISO) + '/' + endDate.toString(forceISO);
    }
    else value = duration.toString(forceISO);

    if (!forceISO) {
        value = normalizeInterval(value);
        this.source || (this.source = value);
    }

    return value;
};

RelativeInterval.prototype.toISOString = function (refdate) {
    var dates = this.toDates(refdate);
    return dates[0].toISOString() + '/' + dates[1].toISOString();
};

RelativeInterval.prototype.toTimestamps = function (refdate) {
    var dates = this.toDates(refdate);
    return [dates[0].getTime(), dates[1].getTime()];
};

RelativeInterval.prototype.toMilliseconds = function (refdate) {
    var dates = this.toDates(refdate);
    return dates[1].getTime() - dates[0].getTime();
};

RelativeInterval.prototype.toSeconds = function (refdate) {
    return this.toMilliseconds(refdate) / 1000;
};

RelativeInterval.prototype.toISODuration = function (refdate) {
    if (this.duration === undefined) {
        return new Duration(this.toMilliseconds(refdate)).toString();
    } else {
        return this.duration.toString();
    }
};

function normalizeInterval(value) {
    var match, res, i;

    if ((res = predefinedIntervalsRevMap[value]) !== undefined) {
        return res;
    }

    if ((match = value.match(lastIntervalsRevRe))) {
        for (i = lastIntervalsPeriods.length; i > 0; --i) {
            if ((res = match[i]) !== undefined) {
                return 'last_' + res + '_' + lastIntervalsPeriods[i - 1];
            }
        }
    }

    return value;
}

function parseInterval(relativeinterval, value) {
    var match, dateStart, dateEnd;

    if (value in predefinedIntervals) {
        relativeinterval.source = value;
        value = predefinedIntervals[value];
    }
    else if ((match = value.match(lastIntervalRe))) {
        relativeinterval.source = value;
        value = lastIntervals[match[2]].replace('x', match[1]);
    }

    value = value.split('/', 2);
    if (value.length === 1) {
        relativeinterval.duration = new Duration(value[0]);
        relativeinterval.relative = true;
    } else {
        if (value[0][0] === 'P') {
                relativeinterval.duration = new Duration(value[0]);
                relativeinterval.end = dateEnd = new RelativeDate(value[1]);
                relativeinterval.relative = dateEnd.relative;
        }
        else if (value[1][0] === 'P') {
            relativeinterval.start = dateStart = new RelativeDate(value[0]);
            relativeinterval.duration = new Duration(value[1]);
            relativeinterval.relative = dateStart.relative;
        }
        else {
            relativeinterval.start = dateStart = new RelativeDate(value[0]);
            relativeinterval.end = dateEnd = new RelativeDate(value[1]);
            relativeinterval.relative = dateStart.relative || dateEnd.relative;
        }
    }
}

module.exports = RelativeInterval;
